module.exports = "/assets/fcdebb8f38a0cf080de0d56ecbdb0ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/U8.png
// module id = 1882
// module chunks = 0